Highcharts.setOptions({ lang: { drillUpText: '◁ Back' } });


const nominowChartDefaults = {
	destroyed: function () {
		if (this.chart) {
			console.log('destroy chart', this.id);
			this.chart.destroy();
		}
	},
	methods: {
		chartDefaults: function (prefix, postfix) {
			return {
				chart: {
					backgroundColor: 'transparent',
				},
				title: {
					text: null
				},
				legend: {
					enabled: false
				},
				tooltip: {
					useHTML: true,
					outside: true,
					backgroundColor: globalColors.primary.hue9,
					formatter: function () {
						//console.log(this);
						let key = this.key;
						if (this.series && this.series.userOptions && this.series.userOptions.id) {
							key += ` (${this.series.userOptions.id})`;
						}
						let series = '';
						if (this.series && this.series.yAxis && this.series.yAxis.axisTitle && this.series.yAxis.axisTitle.textStr) {
							series = this.series.yAxis.axisTitle.textStr || '';
						}
						return `${key}<br/><span style="color:${this.color}">${series}</span>: <strong>${prefix || ''}${this.y}${postfix || ''}</strong>`;
					}
				},
				exporting: {
					buttons: null
				},
				credits: {
					enabled: false
				}

			}
		},
		getMaxAverage: function (data) {
			let max = 0;
			let total = 0;
			for (let i = 0; i < data.length; i += 1) {
				total += data[i].y;
				max = data[i].y > max ? data[i].y : max;
			}
			const average = total / data.length;
			const divider = (max < 100) ? 10 : 100;
			max = Math.ceil(max / divider) * divider;
			max = Math.max(max, parseInt(Math.floor(average) * 2));
			return { max: max, total: total, average: average };
		},
		getMultiMaxAverage: function (data) {
			let max = 0;
			let total = 0;
			for (let i = 0; i < data.length; i += 1) {
				for (let j = 0; j < data[i].data.length; j += 1) {
					total += data[i].data[j];
					max = data[i].data[j] > max ? data[i].data[j] : max;
				}
			}
			const average = total / (data.length * data[0].data.length);
			const divider = (max < 100) ? 10 : 100;
			max = Math.ceil(max / divider) * divider;
			max = Math.max(max, parseInt(Math.floor(average) * 2));
			return { max: max, total: total, average: average };
		},
		getPlotLines: function (initPlotLines, maxAvg, yOffset) {
			const plotlines = window.cloneObject(initPlotLines) || [];
			for (let i = 0; i < plotlines.length; i++) {
				plotlines[i] = $.extend(true, {
					id: 'plotline' + i,
					className: 'chart-plot-line-opacity',
					width: 2,
					zIndex: 8,
					dashStyle: 'Dash',
					label: {
						align: 'left',
						verticalAlign: 'top',
						style: {
							color: plotlines[i].color || globalColors.primary.hue9
						},
						rotation: 0,
						y: yOffset || 0
					}
				}, plotlines[i]);

				if (plotlines[i].value == '[AVG]') {
					plotlines[i].value = maxAvg.average;
					plotlines[i].label.text = plotlines[i].label.text.replace('[AVG]', window.groupDigits(maxAvg.average.toFixed(2)));
				}
			}

			return plotlines;
		}
	}
}

module.exports = {
	mixin: nominowChartDefaults
}
